var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M9.93776 7.4996H7.50027M7.50027 7.4996H5.06276M7.50027 7.4996V9.93709M7.50027 7.4996L7.50026 5.06212M14 3.43749L14 11.5625C14 12.9087 12.9087 14 11.5625 14H3.4375C2.09131 14 1 12.9087 1 11.5625V3.43749C1 2.0913 2.09131 1 3.4375 1H11.5625C12.9087 1 14 2.0913 14 3.43749Z",
          stroke: "#1A7BEE",
          "stroke-width": "1.44444",
          "stroke-linecap": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }